import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';
import Sparkline from '../../components/Sparklines';
import moment from 'moment';
import Actions from './actions';

export const COLUMNS = (ctrNumber = 0.05, t) => [
    {
        label: t('discover.live_optimization.table.page'),
        key: 'page',
        data: 'page',
        sortType: 'string',
        cellSize: 'minmax(150px, 1.5fr)',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return item?.page ?? item?.keys?.[0];
            const data = item.clicks / item.impressions;

            return (
                <div className="live-report-ctr">
                    <div className={`wrap-text ${data < ctrNumber ? 'low' : ''}`}>
                        {decodeURIComponent(item?.page ?? item?.keys?.[0])}
                    </div>
                    <a
                        target="_blank"
                        className="link-website d-inline-flex align-items-center justify-content-center"
                        href={item.page}
                        rel="noreferrer"
                    >
                        <i className="icon-external-link"></i>
                    </a>
                </div>
            );
        },
    },
    {
        label: t('discover.live_optimization.table.clicks'),
        key: 'clicks',
        data: 'clicks',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('discover.live_optimization.table.click_change'),
        key: 'click_change',
        data: 'click_change',
        cellSize: 'minmax(180px, 1fr)',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return '-';
            const sortedValues = item.clicksL.sort(
                (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
            );
            const labels = sortedValues?.map((x) => x.date);
            const values = sortedValues?.map((x) => x.value);
            return (
                <Sparkline dataL={values} keyName="Clicks" labels={labels} titleType={titleType} />
            );
        },
    },
    {
        label: t('discover.live_optimization.table.impressions'),
        key: 'impressions',
        data: 'impressions',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('discover.live_optimization.table.impressions_change'),
        key: 'impressions_change',
        data: 'impressions_change',
        cellSize: 'minmax(180px, 1fr)',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return '-';
            const sortedValues = item.impressionsL.sort(
                (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
            );
            const labels = sortedValues?.map((x) => x.date);
            const values = sortedValues?.map((x) => x.value);
            return (
                <Sparkline
                    dataL={values}
                    keyName="Impressions"
                    labels={labels}
                    titleType={titleType}
                />
            );
        },
    },
    {
        label: t('discover.live_optimization.table.ctr'),
        key: 'ctr',
        data: 'ctr',
        sortType: (array) =>
            array.sort((a, b) => a.clicks / a.impressions - b.clicks / b.impressions),
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            const data = item.clicks / item.impressions;
            if (csvDownload) return data;

            return (
                <div className="live-report-ctr">
                    <strong className={data < ctrNumber ? 'low' : 'high'}>
                        {' '}
                        {numeral(data).format('0.00%')}
                    </strong>
                </div>
            );
        },
    },
    {
        label: t('discover.live_optimization.table.ctr_change'),
        key: 'ctr_change',
        cellSize: 'minmax(180px, 1fr)',
        data: 'ctr_change',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return '-';
            const labels = item.ctrL?.map((x) => x.date);
            const values = item.ctrL?.map((x) => x.value);
            return (
                <Sparkline
                    dataL={values}
                    keyName="CTR"
                    labels={labels}
                    titleType={titleType}
                    customDataType={dataType}
                />
            );
        },
    },
    {
        label: t('discover.live_optimization.table.actions'),
        key: 'actions',
        data: 'actions',
        cellSize: 'minmax(180px, 1fr)',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return '-';
            return <Actions url={item.page} />;
        },
    },
];

function titleType(_, date) {
    return moment(date).format('MMM D, h:mm A');
}

function dataType(data) {
    return numeral(data).format('0.00%');
}
